import api from '../api';
import _ from 'lodash';

const baseUrl = (token) => `profiles/${token}`;

export const getCurrentUserProfilesByToken = async (token) =>
  api({
    method: 'get',
    url: `${baseUrl(token)}`,
  });

export const filterSocialProfiles = (currentProfile) => {
let socialProfiles = [];
  if (!_.isEmpty(currentProfile.social_profiles)) {
    socialProfiles = currentProfile.social_profiles.filter((p) => {
      const { authable, network, username } = p
      return network && username && (authable || ['tiktok', 'kick'].includes(network));
    });
  }

  return socialProfiles;
}

export const addTikTokAccount = (token, profile) =>
  api({
    method: 'post',
    url: `${baseUrl(token)}`,
    data: {
      type: 'tiktok',
      username: profile
    }
  });

export const connectTikTokAccount = (token, profile) =>
  api({
    method: 'patch',
    url: `${baseUrl(token)}/${profile.id}`,
    data: {
      type: 'tiktok',
      username: profile.username
    }
  });

export const addKickAccount = (token, profile) =>
  api({
    method: 'post',
    url: `${baseUrl(token)}`,
    data: {
      type: 'kick',
      username: profile
    }
  });

export const connectKickAccount = (token, profile) =>
  api({
    method: 'patch',
    url: `${baseUrl(token)}/${profile.id}`,
    data: {
      type: 'kick',
      username: profile.username
    }
  });

export const removeNetwork = async (token, profile) =>
  api({
    method: 'delete',
    url: `${baseUrl(token)}/${profile.id}`
  });

export const disconnectNetwork = async (token, profile) =>
  api({
    method: 'patch',
    url: `${baseUrl(token)}/${profile.id}/disconnect`
  });

export const addDiscord = (discordCode, token) =>
  api({
    method: 'post',
    url: `${baseUrl(token)}/add_discord`,
    data: {
      token: discordCode,
      type: 'discord',
    }
  });

export const connectDiscord = (discordCode, token, profileId, username) =>
  api({
    method: 'patch',
    url: `${baseUrl(token)}/${profileId}/connect_discord`,
    data: {
      token: discordCode,
      username: username
    }
  });
